import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import PostTitle from '../components/Title/PostTitle';
import { SectionLayout } from '../components/Layouts';
import * as T from '../components/Typography';
import { Row, Col } from '../components/Grid';
import Image from '../components/PreviewCompatibleImage';
import SocialShare from '../components/SocialShare';

import { GeneralCardsSection } from '../sections/Cards';
import ActionCardsSection from '../sections/ActionCards';
import { ThinkingSection } from '../sections/CardsSections';

import placeholderData from '../utils/placeholderData';
import composeStyle from '../utils/composeStyle';

import * as S from './style';

const Subtitle = composeStyle(T.H4SemiBold, 'H4SemiBold', 'P16Bold');

export const ThinkingPostTemplate = ({
  content,
  title,
  subtitle,
  asideText,
  category,
  imageInfo,
  preview,
  FeedsSectionTitle = 'Thinking Feeds Section ...',
  id,
}) => {
  return (
    <>
      <SectionLayout>
        <Row>
          <Col mb="1.5rem" w={[4, 6, 8]}>
            <PostTitle category={category}>{title}</PostTitle>
          </Col>
        </Row>

        <S.PostDesktopWrapper>
          <Row jc="space-between">
            <Col w={[4, 6, 7]}>
              <S.Content>
                <Subtitle color="gray1" style={{ paddingBottom: 30 }}>
                  {subtitle}
                </Subtitle>
                {content && (
                  <S.PostsContentContainer
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />
                )}
              </S.Content>
            </Col>
            <Col w={[4, 6, 4]}>
              <S.ImgContainer>
                <Image imageInfo={imageInfo} style={{ maxHeight: '250px' }} />
              </S.ImgContainer>
              <T.H5Font16 color="midnight" style={{ paddingTop: 50 }}>
                {asideText}
              </T.H5Font16>
            </Col>
          </Row>
        </S.PostDesktopWrapper>

        <S.PostTabletAndMobileWrapper>
          <Row>
            <Col w={[4, 3, 8]}>
              <Subtitle color="gray1" style={{ paddingBottom: 30 }}>
                {subtitle}
              </Subtitle>
            </Col>
            <Col w={[4, 3, 8]}>
              <S.ImgContainer>
                <Image imageInfo={imageInfo} />
              </S.ImgContainer>
            </Col>
            <Col w={[4, 6, 8]}>
              <T.H5Font16 color="midnight" style={{ padding: '50px 0' }}>
                {asideText}
              </T.H5Font16>
            </Col>
            <Col w={[4, 6, 8]}>
              {content && (
                <S.PostsContentContainer
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />
              )}
            </Col>
          </Row>
        </S.PostTabletAndMobileWrapper>

        {/* social share */}
        <Row>
          <Col mt={5} w={[4, 2, 3]}>
            <SocialShare jc="flex-start" jcT="flex-start" jcM="center" />
          </Col>
        </Row>
      </SectionLayout>
      {preview ? (
        <GeneralCardsSection
          data={placeholderData}
          type="impacts"
          title={FeedsSectionTitle || 'Thinking Feeds Section'}
        />
      ) : (
        <ThinkingSection
          title={FeedsSectionTitle || 'Impact & updates'}
          type="impacts"
          currentId={id}
          bgcolor="gray2"
        />
      )}
      <ActionCardsSection />
    </>
  );
};

const ThinkingPostPage = ({ data }) => {
  const {
    markdownRemark: {
      id,
      html: content,
      frontmatter: { title, subtitle, asideText, category, postImage, FeedsSectionTitle },
    },
  } = data;
  return (
    <Layout isPost>
      <ThinkingPostTemplate
        content={content}
        title={title}
        subtitle={subtitle}
        asideText={asideText}
        category={category}
        imageInfo={postImage}
        FeedsSectionTitle={FeedsSectionTitle}
        id={id}
      />
    </Layout>
  );
};

export const thinkingPost = graphql`
  query thinkingPostQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        subtitle
        asideText
        category
        FeedsSectionTitle
        postImage {
          childImageSharp {
            fluid(quality: 100, maxWidth: 360) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;

export default ThinkingPostPage;
